import { Injectable } from '@angular/core';
import { getKDWBaseUrl } from '../helpers/kdw-base-url.helper';
import { Population } from '../models';
import { OktaHttpReqService } from './okta-http-req.service';

@Injectable()
export class PopulationsService {
    constructor(private oktaHttp: OktaHttpReqService) {}

    // SSPF-3510: routed through segment-api (KDW). See ctx-segment.service.ts.
    private get endpoint(): string {
        return `${getKDWBaseUrl()}/api/v1/populations`;
    }
    private get segmentsEndpoint(): string {
        return `${getKDWBaseUrl()}/api/v1/segments`;
    }

    getAllPopulations() {
        return this.oktaHttp.request('get', this.endpoint);
    }

    update(params: Population) {
        return this.oktaHttp.request('put', `${this.endpoint}/${params.ID}`, params);
    }

    stage(segmentId: number, populationId: number) {
        const endpoint = `${this.segmentsEndpoint}/${segmentId}/populations/${populationId}/stage`;
        return this.oktaHttp.request('put', endpoint, {});
    }

    getPopulationById(segmentId: number, populationId: number) {
        const endpoint = `${this.segmentsEndpoint}/${segmentId}/populations/${populationId}`;
        return this.oktaHttp.request('get', endpoint);
    }
}
